const pathname = window.location.href
const boxersStack = ['boxer-briefs', 'boxer-briefs-underwear-multipacks-europe', 'trunks', 'trunks-europe', 'trunks-dark-blue-exclusives']
const is3packUrl = boxersStack.find(handle => pathname.indexOf(handle) > -1)
if (window.location.search.indexOf('pack=') == -1 && is3packUrl && window?.templateName != "new-pdp-builder" && window?.templateName != "new-pdp-builder-v2") {
	history.pushState({}, null, window.location.pathname + '?pack=3')
}

class StickyAddToCart {
	constructor() {
		this.boxer_twosave = window.boxer_twosave
		this.boxer_threesave = window.boxer_threesave
		this.boxer_sixsave = window.boxer_sixsave
		this.boxer_ninesave = window.boxer_ninesave
		this.briefs_sixsave = window.briefs_sixsave
		this.briefs_ninesave = window.briefs_ninesave
		this.briefsStack = ['briefs']
		this.boxersStack = ['boxer-briefs', 'boxer-briefs-underwear-multipacks-europe', 'trunks', 'trunks-europe', 'trunks-dark-blue-exclusives']
	}
	get regularPriceEl() {
		return document.querySelectorAll('.sticky-cta .regular-price')
	}
	get comparePriceEl() {
		return document.querySelectorAll('.sticky-cta .compare-price')
	}
	get giftBoxInputEl() {
		return document.querySelectorAll('.giftbox-product-id')
	}
	get single_price() {
		return Number(document.querySelector('.sticky-cta .regular-price')?.dataset.singleprice)
	}
	get currency() {
		return document.querySelector('.sticky-cta .compare-price')?.dataset.currency
	}
	get stackType() {
		if (this.briefsStack.indexOf(this.handle) > -1) return 'briefs'
		if (this.boxersStack.indexOf(this.handle) > -1) return 'boxers'
		return 'other'
	}
	get pack() {
		return Number(document.querySelector('.tab-item.active')?.dataset.pack)
	}
	get stackedPack() {
		let pack = this.pack

		this.cart?.items?.forEach(item => {
			if (this.stackType == 'briefs' && this.briefsStack.indexOf(item.handle) > -1) {
				pack += item.quantity * 3
			} else if (this.stackType == 'boxers' && this.boxersStack.indexOf(item.handle) > -1) {
				pack += item.quantity * 3
			}
		})
		return pack
	}
	async getCart() {
		const res = await fetch('/cart.js')
		const cart = await res.json()
		return cart
	}
	async currentProduct() {
		const res = await fetch(window.location.pathname + '.js')
		const currentProduct = await res.json()
		return currentProduct
	}
	get discount() {
		let discount = 1
		if (this.stackType == 'briefs') {
			if (this.pack == 6) {
				discount = this.briefs_sixsave
			}
			if (this.pack >= 9) {
				discount = this.briefs_ninesave
			}
		} else if (this.stackType == 'boxers') {
			if (this.pack == 3) {
				discount = this.boxer_threesave
			}
			if (this.pack == 6) {
				discount = this.boxer_sixsave
			}
			if (this.pack >= 9) {
				discount = this.boxer_ninesave
			}
		} else if (this.stackType == 'other') {
			if (this.pack == 2) {
				discount = this.boxer_twosave
			}
		}
		return discount
	}
	formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
		if (isNaN(number) || !number) {
			return 0
		}

		const preciseNumber = (number / 100.0).toFixed(precision)

		const parts = preciseNumber.split(thousands)
		const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`)
		const centsAmount = parts[1] ? decimal + parts[1] : ''

		return dollarsAmount + centsAmount
	}

	formatMoney(cents) {
		let format = this.currency

		let value = ''
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

		switch (format?.match(placeholderRegex)[1]) {
			case 'amount':
				value = this.formatWithDelimiters(cents, 2, ',', '.')
				break
			case 'amount_with_space_separator':
				value = this.formatWithDelimiters(cents, 2, ' ', '.')
				break
			case 'amount_with_comma_separator':
				value = this.formatWithDelimiters(cents, 2, '.', ',')
				break
			case 'amount_with_apostrophe_separator':
				value = this.formatWithDelimiters(cents, 2, "'", '.')
				break
			case 'amount_no_decimals':
				value = this.formatWithDelimiters(cents, 0, ',', '.')
				break
			case 'amount_no_decimals_with_space_separator':
				value = this.formatWithDelimiters(cents, 0, ' ', '.')
				break
			case 'amount_no_decimals_with_comma_separator':
				value = this.formatWithDelimiters(cents, 0, ',', '.')
				break
		}

		return format?.replace(placeholderRegex, value)
	}
	get qty() {
		if (this.pack <= 3) return 1
		if (this.pack == 6) return 2
		if (this.pack == 9) return 3
	}

	async update() {
		console.log('stickyAddToCart update started')
		this.cart = await this.getCart()
		const currentProduct = await this.currentProduct()
		this.handle = currentProduct.handle
		let comparePrice = this.single_price * this.pack
		let regularPrice = this.single_price * this.pack * this.discount
		this.giftBoxInputEl.forEach(input => {
			if (input.checked) {
				comparePrice += Number(input.dataset.price)
				regularPrice += Number(input.dataset.price)
			}
		})

		let comparePriceFmt = this.formatMoney(comparePrice)
		let regularPriceFmt = this.formatMoney(regularPrice)

		this.comparePriceEl.forEach(price => {
			if (this.discount == 1) {
				price.style.display = 'none'
				return
			}
			price.style.display = 'inline-block'
			price.textContent = comparePriceFmt
		})
		this.regularPriceEl.forEach(price => {
			if (this.discount == 1) {
				price.classList.remove('text-red')
			} else {
				price.classList.add('text-red')
			}
			price.textContent = regularPriceFmt
		})
		let interval
		interval = setInterval(() => {
			if (window.KOSMApp && typeof window.KOSMApp.updatePurchaseAmount === 'function') {
				setTimeout(() => {
					let klarnaammount = regularPrice.toFixed(0)
					window.KlarnaThemeGlobals.data_purchase_amount = klarnaammount
					window.KlarnaThemeGlobals.documentCopy = document.cloneNode(true)
					window.KOSMApp?.updatePurchaseAmount(klarnaammount)
					console.log('set klarna', klarnaammount)
				}, 100)
				clearInterval(interval)
			}
		}, 500)

		console.log('stickyAddToCart updated')
	}
}
let stickyAddToCart
if (document.querySelector('.template--product.product')) {
} else {
	stickyAddToCart = new StickyAddToCart()
}

function initProductPage() {
	// embla slider

	document
		.querySelector('.product__template')
		.querySelectorAll('.embla-slider')
		.forEach((emblaNode, index) => {
			setTimeout(() => {
				const wrap = emblaNode.querySelector('.embla')
				const viewPort = wrap.querySelector('.embla__viewport')
				const prevBtn = wrap.querySelector('.embla__button--prev')
				const nextBtn = wrap.querySelector('.embla__button--next')
				const thumbnails = document.querySelectorAll('.thumbnail')
				const dots = emblaNode.querySelector('.embla__dots')
				let options = { loop: false, align: 'start', draggable: true, containScroll: 'trimSnaps' }
				const embla = EmblaCarousel(viewPort, options)

				const generateDotBtns = () => {
					const template = emblaNode.getElementsByClassName('embla-dot-template')[0].innerHTML
					dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + template, '')
					return [].slice.call(dots.querySelectorAll('.embla__dot'))
				}

				const dotsArray = generateDotBtns()

				if (dotsArray.length > 4) {
					emblaNode.classList.add('embla-buttons__enalbe')
				}

				const setupPrevNextBtns = () => {
					prevBtn.addEventListener('click', embla.scrollPrev, false)
					nextBtn.addEventListener('click', embla.scrollNext, false)
				}

				const setupThumbnails = () => {
					thumbnails.forEach((thumbnail, index) => {
						thumbnail.addEventListener('click', () => {
							// get index of thumbnail element reletave to it's parent element
							let thumbnailParentElement = thumbnail.parentElement.parentElement
							let thumbnailIndex = Array.from(thumbnailParentElement.children).indexOf(thumbnail.parentElement)
							embla.scrollTo(thumbnailIndex), false
						})
					})
				}

				const disablePrevNextBtns = () => {
					return () => {
						if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled')
						else prevBtn.setAttribute('disabled', 'disabled')

						if (embla.canScrollNext()) nextBtn.removeAttribute('disabled')
						else nextBtn.setAttribute('disabled', 'disabled')
					}
				}

				const setupDotBtns = () => {
					dotsArray.forEach((dotNode, i) => {
						dotNode.addEventListener('click', () => embla.scrollTo(i), false)
					})
				}

				const selectDotBtn = () => () => {
					const previous = embla.previousScrollSnap()
					const selected = embla.selectedScrollSnap()
					if (previous != null && selected != null && dotsArray[previous] != null && dotsArray[selected] != null) {
						dotsArray[previous].classList.remove('is-selected')
						dotsArray[selected].classList.add('is-selected')
						if (dotsArray.length > 4) {
							dotsArray.forEach((dot, index) => {
								dot.classList.remove('hidden')
								if (selected == 0 && index >= 4) {
									dot.classList.add('hidden')
								}
								if (selected > dotsArray.length - 4 && index < dotsArray.length - 4) {
									dot.classList.add('hidden')
								}
								if (selected > 0 && selected <= dotsArray.length - 4 && (index < selected - 1 || index > selected + 2)) {
									dot.classList.add('hidden')
								}
							})
						}

						setTimeout(() => {
							document.querySelectorAll('.product-list-slider .embla__dots').forEach(item => {
								item.style.opacity = 1
							})
						}, 100)
					}
				}

				setupPrevNextBtns()
				setupThumbnails()
				setupDotBtns()

				embla.on('select', selectDotBtn())
				embla.on('select', disablePrevNextBtns())
				embla.on('init', selectDotBtn())
				embla.on('select', () => {
					setTimeout(() => {
						let thumbnails = document.querySelectorAll('.embla-thumbnail-list[data-media-current="true"] li button')
						if (thumbnails.length > 0) {
							console.log('thumbnails', thumbnails)
							// remove aria current from all thumbnails
							// remove aria current from all thumbnails
							thumbnails.forEach(item => {
								item.removeAttribute('aria-current')
							})
							let index = embla.selectedScrollSnap()
							thumbnails[index].setAttribute('aria-current', 'true')
						}
					}, 100)
				})

				document.querySelectorAll('.product__giftbox-product--options label').forEach((label, index) => {
					label.addEventListener('click', () => {
						embla.reInit()
					})
				})

				document.querySelectorAll('.variant-type--color label').forEach(item => {
					item.addEventListener('click', () => {
						setTimeout(() => {
							embla.reInit()
							// set first thumbnail active
							let thumbnails = wrap.querySelectorAll('.thumbnail')
							if (thumbnails.length > 0) {
								// remove aria current from all thumbnails
								thumbnails.forEach(item => {
									item.removeAttribute('aria-current')
								})
								thumbnails[0].setAttribute('aria-current', 'true')
							}

							// thumbnails.parentElement.parentElement.children[0].setAttribute('aria-current', 'true');
						}, 100)
					})
				})
			}, 100)
		})

	// product page
	var handle = window.location.href
	var pack = window.location.search.slice(0, 7)
	var variantRadios = document.querySelectorAll('variant-radios')
	var optionLabels = document.querySelectorAll('.option-label')
	var dataUrl = variantRadios[0].dataset.url
	var tabItems = document.querySelectorAll('.packs-tab .tab-item')
	var template = document.querySelector('.product__template')
	var klarnaammount = 0
	const variants = JSON.parse(document.querySelector('variant-radios').querySelector('[type="application/json"]').textContent)

	for (var i = 0; i < tabItems.length; i++) {
		if (handle.indexOf(tabItems[i].getAttribute('href')) > -1) {
			for (var j = 0; j < tabItems.length; j++) {
				tabItems[j].classList.remove('active')
			}
			tabItems[i].classList.add('active')
		}
		if (tabItems[i].classList.contains('active')) {
		}
	}

	if (handle.indexOf('?pack') == -1 && tabItems.length > 0) {
		tabItems[0].classList.add('active')
	}

	document.querySelectorAll('.style--button').forEach(item => {
		item.addEventListener('click', function () {
			document.getElementById('shopify-section-header').classList.remove('shopify-section-header-hidden')
			document.getElementById('shopify-section-header').classList.add('shopify-section-header-sticky')
			document.getElementById('shopify-section-header').classList.add('animate')
			if (window.innerWidth < 990) {
				document.getElementById('shopify-section-header').classList.add('menu-open')
				document.body.classList.add('overflow-hidden-tablet')
			} else {
				document.body.classList.add('overflow-hidden')
			}
			document.querySelector('.style-popup').classList.add('active')
			document.getElementById('over-back').classList.add('active')
		})
	})

	document.querySelectorAll('.style-popup .close-button').forEach(item => {
		item.addEventListener('click', function () {
			document.body.classList.remove('overflow-hidden')
			document.body.classList.remove('overflow-hidden-tablet')
			document.getElementById('shopify-section-header').classList.remove('menu-open')
			document.querySelector('.style-popup').classList.remove('active')
			document.getElementById('over-back').classList.remove('active')
		})
	})

	var styleItems = document.querySelectorAll('.style-popup .tab-item')
	var styleContents = document.querySelectorAll('.style-popup .tab-content')
	for (var i = 0; i < styleItems.length; i++) {
		const index = i
		styleItems[i].addEventListener('click', function () {
			for (var j = 0; j < styleItems.length; j++) {
				styleItems[j].classList.remove('active')
				styleContents[j].classList.remove('active')
			}
			styleItems[index].classList.add('active')
			styleContents[index].classList.add('active')
		})
	}

	document.querySelectorAll('.size-chart--button').forEach(item => {
		item.addEventListener('click', function () {
			$('.bundle-size-guide-pop-up').addClass('active');
			$('body').addClass('overflow-hidden');
		})
	})

	document.querySelectorAll('.bundle-size-guide-pop-up-close').forEach(item => {
		item.addEventListener('click', function () {
			$('.bundle-size-guide-pop-up').removeClass('active');
			$('body').removeClass('overflow-hidden');
		})
	})

	setTimeout(() => {
		document.querySelectorAll('.product-list-slider').forEach(slider => {
			const productSliderList = slider.querySelectorAll('li')
			if (productSliderList.length <= 1) {
				slider.classList.add('embla__disable')
			}
			productSliderList.forEach((slide, index) => {
				if (index == 0) {
					slide.classList.add('is-active')
				} else {
					slide.classList.remove('is-active')
				}
			})
			// slider.querySelector('.embla__button--next').addEventListener('click', function () {
			//     var mediaColor = this.closest('.embla-slider').getAttribute('data-media-color')
			//     console.log(mediaColor);

			//     for (var i = 0; i < productSliderList.length; i++) {
			//         if (productSliderList[i].classList.contains('is-active')) {
			//             productSliderList[i].classList.remove('is-active');
			//             productSliderList[i + 1].classList.add('is-active');
			//             const target0 = productSliderList[i].getAttribute('data-media-id');
			//             const target1 = productSliderList[i + 1].getAttribute('data-media-id');
			//             document.querySelector(`.embla-thumbnail-list[data-media-color="${mediaColor}"]`).querySelector(`[data-target="${target0}"] button`).removeAttribute('aria-current');
			//             document.querySelector(`.embla-thumbnail-list[data-media-color="${mediaColor}"]`).querySelector(`[data-target="${target1}"] button`).setAttribute('aria-current', true);
			//             return;
			//         }
			//     }
			// });

			// slider.querySelector('.embla__button--prev').addEventListener('click', function () {
			//     var mediaColor = this.closest('.embla-slider').getAttribute('data-media-color')
			//     console.log(mediaColor);

			//     for (var i = 0; i < productSliderList.length; i++) {
			//         if (productSliderList[i].classList.contains('is-active')) {
			//             productSliderList[i].classList.remove('is-active');
			//             productSliderList[i - 1].classList.add('is-active');
			//             const target0 = productSliderList[i].getAttribute('data-media-id');
			//             const target1 = productSliderList[i - 1].getAttribute('data-media-id');
			//             document.querySelector(`.embla-thumbnail-list[data-media-color="${mediaColor}"]`).querySelector(`[data-target="${target0}"] button`).removeAttribute('aria-current');
			//             document.querySelector(`.embla-thumbnail-list[data-media-color="${mediaColor}"]`).querySelector(`[data-target="${target1}"] button`).setAttribute('aria-current', true);
			//             return;
			//         }
			//     }
			// });
		})
	}, 100)

	document.querySelectorAll('.embla-thumbnail-list').forEach(thumbnailList => {
		const list = thumbnailList.querySelectorAll('li')
		list.forEach((li, index) => {
			if (index == 0) {
				li.querySelector('button').setAttribute('aria-current', true)
			} else {
				li.querySelector('button').removeAttribute('aria-current')
			}
		})
		thumbnailList.style.width = `${56 * list.length}px`
		list.forEach((thumbnail, index) => {
			thumbnail.addEventListener('click', function () {
				var productDots = document.querySelector('.product-list-slider').querySelectorAll('.embla__dot')
				if (template.classList.contains('product-main')) {
					productDots = document.querySelector('.product-list-slider[data-media-current="true"]').querySelectorAll('.embla__dot')
				}
				if (window.tpl_version == 1) {
					productDots[index]?.click()
				}
			})
		})
	})

	document.querySelectorAll('.variant-type--pouch-type label').forEach(item => {
		item.addEventListener('click', function () {
			const label = this.textContent.trim()
			switch (label) {
				case 'Active - with Pouch':
					if (document.querySelector('.product-style--active')) {
						document.querySelector('.product-style--active').click()
					}
					break
				case 'Pro - without Pouch':
					if (document.querySelector('.product-style--pro')) {
						document.querySelector('.product-style--pro').click()
					}
					break

				default:
					break
			}
		})
	})

	function changeGiftVariant(target) {
		setTimeout(() => {
			if (target && document.getElementById('allow-giftbox').checked) {
				if (template.classList.contains('product-main') && document.querySelectorAll('.product-list-slider').length > 1) {
					document.querySelectorAll('.product-list-slider').forEach(slider => {
						const color = slider.getAttribute('data-media-color')
						if (color.indexOf('gift_product_media') > -1) {
							slider.setAttribute('data-media-current', true)
						} else {
							slider.setAttribute('data-media-current', false)
						}
					})

					document.querySelectorAll('.embla-thumbnail-list').forEach(slider => {
						const color = slider.getAttribute('data-media-color')
						if (color.indexOf('gift_product_media') > -1) {
							slider.setAttribute('data-media-current', true)
						} else {
							slider.setAttribute('data-media-current', false)
						}
					})
				}
				document.querySelector(`.${target}`).click()
			} else {
				let isSlectedColor = false
				document.querySelectorAll('.variant-type--color input').forEach(input => {
					if (input.classList.contains('active') && input.checked) {
						const mediaColor = input.nextElementSibling.getAttribute('data-option-color')
						document.querySelectorAll('.product-list-slider').forEach(slider => {
							if (slider.getAttribute('data-media-color').indexOf(mediaColor) > -1) {
								slider.setAttribute('data-media-current', true)
							} else {
								slider.setAttribute('data-media-current', false)
							}
						})

						document.querySelectorAll('.embla-thumbnail-list').forEach(slider => {
							if (slider.getAttribute('data-media-color').indexOf(mediaColor) > -1) {
								slider.setAttribute('data-media-current', true)
							} else {
								slider.setAttribute('data-media-current', false)
							}
						})
						isSlectedColor = true
						return false
					}
				})
				if (!isSlectedColor) {
					document.querySelectorAll('.product-list-slider').forEach((slider, index) => {
						if (index == 0) {
							slider.setAttribute('data-media-current', true)
						} else {
							slider.setAttribute('data-media-current', false)
						}
					})

					document.querySelectorAll('.embla-thumbnail-list').forEach((slider, index) => {
						if (index == 0) {
							slider.setAttribute('data-media-current', true)
						} else {
							slider.setAttribute('data-media-current', false)
						}
					})
				}
			}
		}, 50)
	}

	document.querySelectorAll('.product__giftbox-product').forEach(item => {
		if (!item.classList.contains('product-with-variants')) {
			item.addEventListener('click', function () {
				if (template.classList.contains('product-main') && document.querySelectorAll('.product-list-slider').length > 1) {
					const currentColor = this.getAttribute('data-option-color')
					document.querySelectorAll('.product-list-slider').forEach(slider => {
						const color = slider.getAttribute('data-media-color')
						if (color.indexOf(currentColor) > -1) {
							slider.setAttribute('data-media-current', true)
						} else {
							slider.setAttribute('data-media-current', false)
						}
					})

					document.querySelectorAll('.embla-thumbnail-list').forEach(slider => {
						const color = slider.getAttribute('data-media-color')
						if (color.indexOf(currentColor) > -1) {
							slider.setAttribute('data-media-current', true)
						} else {
							slider.setAttribute('data-media-current', false)
						}
					})
				}
				changeGiftVariant(this.dataset.target)
			})
		}
	})

	document.querySelectorAll('.product__giftbox-product--option').forEach(option => {
		option.addEventListener('click', function () {
			const variantId = this.getAttribute('data-variant-id')
			const variantTitle = this.getAttribute('data-variant-title')
			this.closest('.product__giftbox--product--detail').querySelector('.product__giftbox-product--color').querySelector('span').textContent = variantTitle
			var _productImages = this.closest('.product__giftbox-product').querySelectorAll('.image')
			_productImages.forEach(image => {
				if (variantId == image.getAttribute('data-variant-id')) {
					image.classList.add('active')
				} else {
					image.classList.remove('active')
				}
			})

			changeGiftVariant(this.dataset.target)
		})
	})

	if (document.querySelector('.product__giftbox-text')) {
		document.querySelector('.product__giftbox-text').addEventListener('click', function () {
			var target = ''
			if (document.querySelector('.product__giftbox-product').classList.contains('product-with-variants')) {
				target = document.querySelector('.product__giftbox-product').querySelector('.product__giftbox-product--option').dataset.target
				document
					.querySelector('.product__giftbox-product')
					.querySelectorAll('.giftbox-product-id')
					.forEach(input => {
						if (input.checked) {
							target = this.dataset.target
						}
					})
			} else {
				target = document.querySelector('.product__giftbox-product').dataset.target
			}

			changeGiftVariant(target)
		})
	}

	if (template.classList.contains('product-main')) {
		if (pack.indexOf('?pack=1') > -1 || pack.indexOf('?pack=2') > -1 || pack.indexOf('?pack=3') > -1 || pack.indexOf('?pack=') == -1) {
			variantRadios.forEach((item, index) => {
				if (index >= 1) {
					item.remove()
					document.querySelector(`[name="items[${index}]['id']"]`).remove()
				} else {
					if (pack) {
						item.setAttribute('data-url', dataUrl + pack)
					} else {
						if (tabItems.length > 0) item.setAttribute('data-url', dataUrl + '?pack=' + tabItems[0].dataset.pack)
					}
				}
			})
			document.querySelectorAll('.variant-pack').forEach((pack, index) => {
				if (index > 0) {
					pack.previousElementSibling.remove()
					pack.remove()
				} else {
					pack.querySelector('.variant-pack__label').remove()
				}
			})
			document.querySelector('.variant-packs').classList.add('single-pack')
			document.querySelectorAll('.js-pack-word').forEach(word => {
				word.textContent = 'Colour:'
			})
		} else if (pack.indexOf('?pack=6') > -1) {
			variantRadios.forEach((item, index) => {
				if (index > 1) {
					item.remove()
					document.querySelector(`[name="items[${index}]['id']"]`).remove()
				} else {
					item.setAttribute('data-url', dataUrl + pack)
				}
			})
			document.querySelectorAll('.variant-pack')[2].remove()
			document.querySelectorAll('.variant-pack__checkbox')[2].remove()
			// window.scrollTo({ left: 0, top: document.querySelector('[data-pack="6"]').offsetTop, behavior: "smooth" });
			if (document.querySelector('.product__giftbox')) {
				document.querySelector('.product__giftbox').remove()
			}

			document.querySelectorAll('.js-pack-word').forEach(word => {
				word.textContent = 'three colours:'
			})
			if (document.querySelector('[data-pack="1"]').querySelector('.js-pack-word') != null) {
				document.querySelector('[data-pack="1"]').querySelector('.js-pack-word').textContent = '2nd pack of three colours:'
			}
		} else if (pack.indexOf('?pack=9') > -1) {
			variantRadios.forEach((item, index) => {
				item.setAttribute('data-url', dataUrl + pack)
			})
			// window.scrollTo({ left: 0, top: document.querySelector('[data-pack="9"]').offsetTop, behavior: "smooth" });
			if (document.querySelector('.product__giftbox')) {
				document.querySelector('.product__giftbox').remove()
			}
			document.querySelectorAll('.js-pack-word').forEach(word => {
				word.textContent = 'three colours:'
			})
			document.querySelectorAll('.js-pack-word-order').forEach((word, index) => {
				switch (index) {
					case 0:
						word.textContent = '2nd pack of'
						break
					case 1:
						word.textContent = '1st pack of'
						break
					default:
						break
				}
			})
			if (document.querySelector('[data-pack="1"]').querySelector('.js-pack-word') != null) {
				document.querySelector('[data-pack="1"]').querySelector('.js-pack-word').textContent = '3rd pack of three colours:'
			}
		}

		document.querySelector('.tab-item.active').classList.remove('barba__link')

		var pair = Number(document.querySelector('.tab-item.active').dataset.pack)

		setTimeout(() => {
			$('.product-reviews').empty()
			$('[data-product-review]').each(function () {
				const index = $(this).data('index')
				if (pair < 3 && index == pair) {
					$('.product-reviews').append($(this).html())
				}
				if (pair >= 3 && index == 3) {
					$('.product-reviews').append($(this).html())
				}
			})
		}, 1500)

		$('.yotpo-widget-item').addClass('hidden')
		var widgetIndex = pair
		if (widgetIndex > 3) {
			widgetIndex = 3
		}
		$(`.yotpo-widget--${widgetIndex}`).removeClass('hidden')

		$(document).on('click', '.star-clickable', function (e) {
			e.preventDefault()
			const posTop = document.querySelector('.custom-yotpo-widget').offsetTop
			window.scrollTo({ left: 0, top: posTop - 100, behavior: 'smooth' })
		})

		document.querySelector('.variant-packs').classList.remove('hidden')

		if (window.location.search.indexOf('&variant=') > -1) {
			const currentVariantId = window.location.search.split('variant=')[1]
			const currentVariant = variants.find(variant => {
				return variant.id == currentVariantId
			})
			document.querySelectorAll('.product-form__input input').forEach(input => {
				input.classList.add('active')
				if (input.checked) {
					setTimeout(() => {
						if (input.closest('.product-form__input').classList.contains('variant-type--color')) {
							if (!currentVariant.available) {
								input.closest('.product-form__input').querySelector('.label__text').classList.add('disabled')
							}
						}
						debugger
						input.nextElementSibling.click()
					}, 100)
				}
			})
		}

		if (document.getElementById('allow-giftbox')) {
			document.getElementById('allow-giftbox').addEventListener('change', function () {
				stickyAddToCart?.update()
			})

			document.querySelectorAll('.product__giftbox-product--option').forEach(item => {
				item.addEventListener('click', function () {
					stickyAddToCart?.update()
				})
			})
		}
	} else if (template.classList.contains('product-regular')) {
		var pair = Number(document.querySelector('.tab-item.active').dataset.pack)
		if (pair == 2) {
			document.querySelector('[data-pair="1"]').classList.add('hidden')
			document.querySelector('[data-pair="2"]').classList.remove('hidden')
		}
	}

	document.querySelectorAll('.product-form__label').forEach(label => {
		label.addEventListener('click', function () {
			if (document.querySelector('.packs-tab')) {
				document.querySelector('.packs-tab').classList.remove('collapse')
				document.querySelector('.tab-item.active').classList.add('selected')
				var color = '',
					size = '',
					style = ''
				var val = this.getAttribute('data-option-value')
				var formInput = this.closest('.product-form__input')
				if (formInput.classList.contains('variant-type--size')) {
					switch (val) {
						case 'S':
							val = '70-75 cm | 27-29 in'
							size = ', small'
							break
						case 'M':
							val = '76-82 cm | 30-32 in'
							size = ', medium'
							break
						case 'L':
							val = '83-89 cm | 33-35 in'
							size = ', large'
							break
						case 'XL':
							val = '90-100 cm | 36-39 in'
							size = ', extra large'
							break
						case 'XXL':
							val = '101-111 cm | 40-44 in'
							size = ', extra extra large'
							break

						default:
							break
					}
					formInput.querySelectorAll('.variant-type--size input').forEach(item => {
						item.classList.add('active')
					})
					// remove red text colour on the closest form label
					formInput.querySelector('.variant__form strong').style.color = '#000'
					if (window.tpl_version == 2) {
						document.querySelectorAll(`[data-option-value="${label.dataset.optionValue}"]`).forEach(c_label => {
							c_label.click()
						})
					}
				}
				if (formInput.classList.contains('variant-type--pouch-type')) {
					switch (val) {
						case 'Active - with Pouch':
							val = 'Active'
							style = ', active'
							break
						case 'Pro - without Pouch':
							val = 'Pro'
							style = ', pro'
							break

						default:
							break
					}
					formInput.querySelectorAll('.variant-type--pouch-type input').forEach(item => {
						item.classList.add('active')
					})
					// remove red text colour on the closest form label
					formInput.querySelector('.variant__form strong').style.color = '#000'
					console.log(formInput.parentElement.querySelector('strong'))
					if (template.classList.contains('product-main') && document.querySelectorAll('.product-list-slider').length > 1) {
						var currentColor = this.getAttribute('data-option-color')
						currentColor = currentColor.split('-')[0]
						document.querySelectorAll('.product-list-slider').forEach(slider => {
							const color = slider.getAttribute('data-media-color')
							if (color == currentColor) {
								slider.setAttribute('data-media-current', true)
							} else {
								slider.setAttribute('data-media-current', false)
							}
						})

						document.querySelectorAll('.embla-thumbnail-list').forEach(slider => {
							const color = slider.getAttribute('data-media-color')
							if (color == currentColor) {
								slider.setAttribute('data-media-current', true)
							} else {
								slider.setAttribute('data-media-current', false)
							}
						})
					}
					if (window.tpl_version == 2) {
						document.querySelectorAll(`[data-option-value="${label.dataset.optionValue}"]`).forEach(c_label => {
							c_label.click()
						})
					}
				}
				if (formInput.classList.contains('variant-type--color')) {
					formInput.querySelectorAll('.variant-type--color input').forEach(item => {
						item.classList.add('active')
					})
					// remove red text colour on the closest form label
					formInput.querySelector('.variant__form strong').style.color = '#000'
					color = ', ' + val
				}
				formInput.querySelector('.label__text').textContent = val
				formInput.querySelector('.label__text').style.color = '#2d2d2d'
				if (formInput.classList.contains('variant-type--color')) {
					if (template.classList.contains('product-main') && document.querySelectorAll('.product-list-slider').length > 1) {
						const currentColor = this.getAttribute('data-option-color')
						document.querySelectorAll('.product-list-slider').forEach(slider => {
							const color = slider.getAttribute('data-media-color')
							if (color.indexOf(currentColor) > -1) {
								slider.setAttribute('data-media-current', true)
							} else {
								slider.setAttribute('data-media-current', false)
							}
						})

						document.querySelectorAll('.embla-thumbnail-list').forEach(slider => {
							const color = slider.getAttribute('data-media-color')
							if (color.indexOf(currentColor) > -1) {
								slider.setAttribute('data-media-current', true)
							} else {
								slider.setAttribute('data-media-current', false)
							}
						})
					}
					setTimeout(() => {
						document.querySelector('.product__media-item.is-active').classList.remove('is-active')
						document.querySelectorAll('.product__media-item')[0].classList.add('is-active')
						document.querySelectorAll('.product-list-slider .embla__dot')[0].click()
					}, 50)
				}

				var varinatPack = this.closest('.variant-pack')
				if (varinatPack) {
					varinatPack
						.querySelector('.variant-type--color')
						.querySelectorAll('input')
						.forEach(input => {
							if (input.classList.contains('active') && input.checked && !color) {
								color = ', ' + input.value
							}
						})
					varinatPack
						.querySelector('.variant-type--size')
						.querySelectorAll('input')
						.forEach(input => {
							if (input.classList.contains('active') && input.checked && !size) {
								switch (input.value) {
									case 'S':
										size = ', small'
										break
									case 'M':
										size = ', medium'
										break
									case 'L':
										size = ', large'
										break
									case 'XL':
										size = ', extra large'
										break
									case 'XXL':
										size = ', extra extra large'
										break

									default:
										break
								}
							}
						})
					var isStyle = false
					if (varinatPack.querySelector('.variant-type--pouch-type')) {
						varinatPack
							.querySelector('.variant-type--pouch-type')
							.querySelectorAll('input')
							.forEach(input => {
								if (input.classList.contains('active') && input.checked && !style) {
									switch (input.value) {
										case 'Active - with Pouch':
											style = 'active'
											break
										case 'Pro - without Pouch':
											style = 'pro'
											break

										default:
											break
									}
								}
							})
						isStyle = true
					}

					var customPack = style + color + size

					if (customPack[0] == ',') {
						customPack = customPack.slice(2)
					}

					if (varinatPack.querySelector('.variant-pack__values')) {
						varinatPack.querySelector('.variant-pack__values').textContent = customPack
						if ((color && size && style && !varinatPack.classList.contains('active')) || (color && size && !style && !isStyle && !varinatPack.classList.contains('active'))) {
							setTimeout(() => {
								if (!document.querySelector('.product-form__submit').classList.contains('disabled')) {
									varinatPack.classList.add('active')
									if (window.tpl_version == 1) {
										varinatPack.previousElementSibling.checked = false
									}
									if (varinatPack.nextElementSibling && window.tpl_version == 1) {
										varinatPack.nextElementSibling.checked = true
									} else {
										if (document.querySelector('.product-form__disabled')) {
											document.querySelector('.product-form__disabled .btn__text').textContent = document.querySelector('.product-form__disabled .btn__text').dataset.initText
											document.querySelector('.product-form__disabled').classList.remove('product-form__disabled')
										}
									}
								}
							}, 100)
						}
					}

					if (document.querySelector('.variant-packs').classList.contains('single-pack')) {
						if ((color && size && style) || (color && size && !style && !isStyle)) {
							if (document.querySelector('.product-form__disabled')) {
								document.querySelector('.product-form__disabled .btn__text').textContent = document.querySelector('.product-form__disabled .btn__text').dataset.initText
								document.querySelector('.product-form__disabled').classList.remove('product-form__disabled')
							}
						}
					}
				}

				setTimeout(() => {
					const currentVariantId = window.location.search.split('variant=')[1]
					const currentVariant = variants.find(variant => {
						return variant.id == currentVariantId
					})
					var isValid = true
					var variantRadio = this.closest('variant-radios')
					variantRadio.querySelectorAll('input').forEach(input => {
						if (!input.classList.contains('active')) {
							isValid = false
						}
					})

					if (isValid && !currentVariant.available) {
						variantRadio.querySelector('.variant-type--color .label__text').classList.add('disabled')
						if (document.querySelector('.klaviyo-bis-trigger')) {
							document.querySelector('.product-form__submit').style.setProperty('display', 'none', 'important')
							document.querySelector('.klaviyo-bis-trigger').style.setProperty('display', 'block', 'important')
						} else {
							document.querySelector('.product-form__submit').style.setProperty('display', 'block', 'important')
						}
					} else {
						variantRadio.querySelector('.variant-type--color .label__text').classList.remove('disabled')
						document.querySelector('.product-form__submit').style.setProperty('display', 'flex', 'important')
						if (document.querySelector('.klaviyo-bis-trigger')) {
							document.querySelector('.klaviyo-bis-trigger').style.setProperty('display', 'none', 'important')
						}
					}

					if (isValid) {
						document.querySelectorAll('.variant-on-sale').forEach(item => {
							if (item.dataset.id == currentVariantId && currentVariant.available) {
								item.classList.remove('hidden')
							} else {
								item.classList.add('hidden')
							}
						})

						document.querySelectorAll('.variant-sold-out').forEach(item => {
							if (currentVariant.available) {
								item.classList.add('hidden')
							} else {
								item.classList.remove('hidden')
							}
						})
					}
				}, 50)
			} else {
				var formInput = this.closest('.product-form__input')
				// add active to all inputs in the same group
				formInput.querySelectorAll('input').forEach(input => {
					input.classList.add('active')
				})
				// remove red text colour on the closest form label
				if (formInput.parentElement.querySelector('strong')) {
					formInput.parentElement.querySelector('strong').style.color = '#000'
				} else {
					formInput.parentElement.querySelector('label').style.color = '#000'
				}
			}
		})
	})

	if (document.querySelector('.image-with-text__form .button')) {
		document.querySelector('.image-with-text__form .button').addEventListener('click', function (e) {
			e.preventDefault()
			const posTop = document.querySelector('.product-form__submit').offsetTop
			window.scrollTo({ left: 0, top: posTop - 100, behavior: 'smooth' })
		})
	}

	if (document.querySelector('.tab-item.active')) {
		document.querySelector('.tab-item.active').addEventListener('click', function (e) {
			e.preventDefault()
			e.stopPropagation()
			if (document.querySelector('.packs-tab').classList.contains('collapse')) {
				document.querySelector('.packs-tab').classList.remove('collapse')
				this.classList.add('selected')
			} else {
				document.querySelector('.packs-tab').classList.add('collapse')
				this.classList.remove('selected')
			}
		})
	}

	if (document.querySelector('.sticky-cta')) {
		window.addEventListener('scroll', event => {
			let scroll = this.scrollY
			let colorTop = document.querySelector('.variant-packs').offsetTop + document.querySelector('.variant-packs').offsetHeight
			document.querySelectorAll('.variant-type--color').forEach(color => {
				if (color.closest('.variant-pack').previousElementSibling.checked) {
					colorTop = color.closest('.variant-pack').offsetTop + color.closest('.variant-pack').offsetHeight
					return false
				}
			})
			if (scroll + this.innerHeight > colorTop && this.innerWidth < 750) {
				document.querySelector('.sticky-cta').classList.add('active')
			} else {
				document.querySelector('.sticky-cta').classList.remove('active')
			}
		})
	}

	document.querySelectorAll('.product__giftbox-product--option').forEach(giftboxOption => {
		giftboxOption.addEventListener('click', function (event) {
			// const optionChecked = this.previousElementSibling.checked
			// setTimeout(() => {
			//     if (optionChecked) {
			//         this.previousElementSibling.checked = false;
			//         this.closest('.product__giftbox-product').classList.remove('checked');
			//     } else {
			//         this.closest('.product__giftbox-product').classList.add('checked');
			//     }
			// }, 100);
		})
	})
	if (document.querySelector('.packs-tab')) {
		document.querySelector('.packs-tab').classList.add('collapse')
	}
    // for duo-pack product, select variant on initial load
  	if(window.tpl_version == 2){
  		let searchParams = new URLSearchParams(window.location.search);
  		if(searchParams.has('variant')){
  			let selectedVariantId = searchParams.get('variant');
  			let selectedVariant = variants?.find((v) => v.id == selectedVariantId);
  			if(selectedVariant){
  				let selectedVariantOptions = selectedVariant?.options;
  				selectedVariantOptions.forEach((opt) => {
  					document.querySelector('.product-form__label[data-option-value="'+opt+'"]')?.click();
  				})
  			}
  		}
  	}
	stickyAddToCart.update()
}

$(window).on('resize', function () {
	if (document.querySelector('.style-popup') && window.innerWidth < 540) {
		document.querySelector('.style-popup').style.height = window.innerHeight - 50 + 'px'
		document.querySelector('.bundle-size-guide-pop-up').style.height = window.innerHeight - 50 + 'px'
	}

	if (window.innerWidth < 540) {
		document.querySelector('.custom-cart-drawer').style.height = window.innerHeight + 'px'
	}
})

document.querySelectorAll('body.product-gift-card variant-radios input[type="radio"]').forEach(option => {
	option.addEventListener('click', function () {
		document.querySelector('body.product-gift-card variant-radios .variant__form .label__text').textContent = this.dataset.price
	})
})

initProductPage()
if (document.querySelector('.loading-product')) {
	document.querySelector('.loading-product').classList.remove('loading-product')
}
